<div
  class="flex flex-col gap-1 rounded-lg px-3 py-2 md:gap-2 md:rounded-2xl"
  [style.background]="'color-mix(in srgb, ' + accentColor + ' 18%, white)'"
>
  <div class="flex min-w-0 items-center gap-1.5 md:gap-2">
    @if (selectionMode) {
      <span class="flex shrink-0" [attr.title]="'board_v3_select_all_in_column' | translate">
        <app-checkbox
          [checked]="allSelected"
          [indeterminate]="!allSelected && someSelected"
          [disableRipple]="true"
          (change)="onSelectAll.emit(column)"
        />
      </span>
    } @else {
      <span class="h-2 w-2 rounded-full" [style.backgroundColor]="accentColor"></span>
    }
    <span class="min-w-0 flex-1 truncate text-[11px] font-semibold uppercase md:flex-none md:text-xs md:tracking-wide" [style.color]="accentColor">
      {{ column.name }}
    </span>
    @if (systemTypeLabelKey) {
      <span
        class="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-white/70"
        [style.color]="accentColor"
        [attr.title]="systemTypeLabelKey | translate"
      >
        <app-icon class="!h-4 !w-4 !text-[16px] !leading-4">{{ systemTypeIcon }}</app-icon>
      </span>
    }
    <span
      class="inline-flex min-w-5 shrink-0 items-center justify-center rounded-full px-1.5 py-0.5 text-xs font-semibold"
      [style.backgroundColor]="accentColor"
      [style.color]="accentTextColor"
    >
      {{ column.count_cards }}
    </span>
    <span class="inline-flex shrink-0 items-center justify-center rounded-full bg-yellow-400 px-1.5 py-0.5 text-xs font-semibold text-black">
      {{ localCount }}
    </span>

    <div class="ml-auto flex shrink-0 items-center gap-1 text-gray-500">
      <button
        type="button"
        class="flex h-8 w-8 items-center justify-center rounded-md! hover:bg-black/5 md:h-6 md:w-6 md:rounded"
        (click)="onAdd.emit(column)"
      >
        <app-icon>add</app-icon>
      </button>
      <button
        type="button"
        class="flex h-8 w-8 items-center justify-center rounded-md! hover:bg-black/5 md:h-6 md:w-6 md:rounded"
        [attr.aria-label]="'board_v3_column_actions' | translate"
        [cdkMenuTriggerFor]="columnMenu"
      >
        <app-icon>more_vert</app-icon>
      </button>
    </div>
  </div>

  <div class="truncate text-sm font-bold text-gray-900 md:text-base">
    {{ column.currency }} {{ column.profit ?? 0 }}
  </div>
</div>

<ng-template #columnMenu>
  <div cdkMenu class="min-w-48 rounded-xl border border-gray-100 bg-white p-1.5 shadow-lg">
    <button
      type="button"
      cdkMenuItem
      class="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-50"
      (click)="onMore.emit(column)"
    >
      <app-icon class="!h-4 !w-4 !text-[16px] !leading-4 text-gray-500">edit</app-icon>
      <span>{{ 'board_v3_edit_stage' | translate }}</span>
    </button>
    <div class="my-1 h-px bg-gray-100"></div>
    <button
      type="button"
      cdkMenuItem
      class="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm text-red-600 hover:bg-red-50"
      (click)="onClear.emit(column)"
    >
      <app-icon class="!h-4 !w-4 !text-[16px] !leading-4">delete_sweep</app-icon>
      <span>{{ 'board_v3_clear_column' | translate }}</span>
    </button>
  </div>
</ng-template>
